import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicLaplaceTransform = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="PROPERTIES OF LAPLACE TRANSFORM"
      videos={[
        "https://www.youtube.com/embed/_KwAE2ODrpU?list=PLhSp9OSVmeyIYLVvSJ8m6KvVwJs7M9QBm",
        "https://www.youtube.com/embed/A25RKV4kY6Y?list=PLhSp9OSVmeyIYLVvSJ8m6KvVwJs7M9QBm",
        "https://www.youtube.com/embed/muS2ancwoQs?list=PLhSp9OSVmeyIYLVvSJ8m6KvVwJs7M9QBm",
        "https://www.youtube.com/embed/1TDSYDp0ehs?list=PLhSp9OSVmeyIYLVvSJ8m6KvVwJs7M9QBm",
        "https://www.youtube.com/embed/2E8RHTL7DmU?list=PLhSp9OSVmeyIYLVvSJ8m6KvVwJs7M9QBm",
        "https://www.youtube.com/embed/H2w06-qYtB8?list=PLhSp9OSVmeyIYLVvSJ8m6KvVwJs7M9QBm",
        "https://www.youtube.com/embed/E4OVdPMMlO8?list=PLhSp9OSVmeyIYLVvSJ8m6KvVwJs7M9QBm",
        "https://www.youtube.com/embed/s2IuoytNhL4?list=PLU6SqdYcYsfIWugLkTq1nMoU3rDDx7xpG",
        "https://www.youtube.com/embed/Idzba9dV6Hc?list=PLU6SqdYcYsfIWugLkTq1nMoU3rDDx7xpG",
        "https://www.youtube.com/embed/lWBQWk4NjLU?list=PLU6SqdYcYsfIWugLkTq1nMoU3rDDx7xpG",
      ]}
      takeaways={[
        { text: "Properties of laplace transform:" },
        { text: "- First video" },
        { text: "Second Shifting Property:" },
        { text: "Unit Step Function:" },
        { text: "- Second video" },
        { text: "- Third video" },
        { text: "- Fourth video" },
        { text: "Direct Delta Function / Unit Impulse Function:" },
        { text: "- Fifth video" },
        { text: "- Sixth video" },
        { text: "- Seventh video" },
        { text: "If you have good grip on how to and when to use the properties, then it is recommended to practice more problems rather than seeing a separate video on properties." },
        { text: "First Shifting Property:" },
        { text: "- Eighth video" },
        { text: "Multiplication Property:" },
        { text: "- Ninth video" },
        { text: "Division Property:" },
        { text: "- Tenth video" },
        { text: "Focus more on second shifting property,remaining properties are generally used in solving steps in problems "}
      ]}
      questions={[]} // Empty questions as there were none provided
      exampleVideos={[]} // Empty example videos
    />
);
}

export default ModuleSubtopicLaplaceTransform;